export interface ColorsType {
  accent: string;
  accentDark: string;
  black: string;
  border: string;
  borderAccent: string;
  danger: string;
  error: string;
  errorDark: string;
  dark0: string;
  dark1: string;
  dark2: string;
  dark3: string;
  light1: string;
  lightPrimary: string;
  primary: string;
  primaryLight: string;
  primaryDark: string;
  success: string;
  successSecondary: string;
  transparent: string;
  white: string;
  lightYellow: string;
  yellow: string;
  disabledGrayedOut: string;
  background: string;
  lighterVibrantGreen: string;
  backgroundGray: string;
  backgroundGraySecondary: string;
  backgroundOeBlue10: string;
  backgroundOeBlue20: string;
  oeBackgroundLightBlue: string;
  secondaryPacificBlueDark: string;
  aquamarine: string;
  blueMediumJr: string;
  facebookBlue: string;
  twitterBlue: string;
  linkedinBlue: string;
  whatsappGreen: string;
  toastSuccessBackground: string;
  toastSuccessBorder: string;
  toastSuccessText: string;
  toastWarningBackground: string;
  toastWarningBorder: string;
  toastWarningText: string;
  olive: string;
  fuxia: string;
  sunnyOrangeLight: string;
  dynamicPrimary: string;
  nuBlue: string;
  text: string;
  secondaryHappyPink: string;
  dropdownHoveredTextColor: string;
  aquaBlue: string;
  blueDark: string;
  bodyCopy: string;
  backgroundsDarkGray: string;
}

const oeColorsShared = {
  accent: '#ff6600',
  accentDark: '#ed6b2c',
  black: '#000000',
  borderAccent: '#7b61ff',
  danger: '#B00020',
  error: '#F41D1D',
  errorDark: '#CF0A0A',
  primaryLight: '#3393FF',
  success: '#7EE600',
  successSecondary: '#01DB8C',
  transparent: 'transparent',
  white: '#FFFFFF',
  lightYellow: '#FAEEA2',
  yellow: '#FFFF00',
  lighterVibrantGreen: '#BCF85C',
  backgroundGray: '#f5f5f5',
  backgroundsDarkGray: '#DEDEDE',
  backgroundGraySecondary: '#F7F8FB',
  backgroundOeBlue10: '#E5F1FF',
  backgroundOeBlue20: '#DDEEFE',
  oeBackgroundLightBlue: '#EDF5FF',
  secondaryPacificBlueDark: '#00005C',
  aquamarine: '#00cad4',
  blueMediumJr: '#EBF7FF',
  facebookBlue: '#0080FF',
  twitterBlue: '#05C3FF',
  linkedinBlue: '#0A66C2',
  whatsappGreen: '#25D366',
  toastSuccessBackground: '#D1E7DD',
  toastSuccessBorder: '#BADBCC',
  toastSuccessText: '#0F5132',
  toastWarningBackground: '#FFF3CD',
  toastWarningBorder: '#FFECB5',
  toastWarningText: '#664D03',
  olive: '#A0C13A',
  fuxia: '#F228C1',
  sunnyOrangeLight: '#FF8533',
  dynamicPrimary: '#0078FF',
  nuBlue: '#0D3C80',
  secondaryHappyPink: '#FF2846',
  dropdownHoveredTextColor: '#0078FF',
  aquaBlue: '#00DBD1',
  blueDark: '#0060CC',
  bodyCopy: '#6D758D',
};

export const oeColors: ColorsType = {
  ...oeColorsShared,
  border: '#dcdcdc',
  dark0: '#222222',
  dark1: '#444444',
  dark2: '#666666',
  dark3: '#999999',
  light1: '#f0f0f0',
  lightPrimary: '#EDF6FF',
  primary: '#0078FF',
  primaryDark: '#005DC8',
  disabledGrayedOut: 'rgba(0,0,0,0.5)',
  background: '#ffffff',
  text: '#000000',
};

export const oeColorsDark: ColorsType = {
  ...oeColorsShared,
  border: '#222222',
  dark0: '#fefefe',
  dark1: '#eeeeee',
  dark2: '#dddddd',
  dark3: '#cccccc',
  light1: '#333333',
  lightPrimary: '#eeeeee',
  primary: '#ffffff',
  primaryDark: '#ffffff',
  disabledGrayedOut: 'rgba(255,255,255,0.5)',
  background: '#363636',
  text: '#000000',
};

export const oeColorsBlue: ColorsType = {
  ...oeColorsShared,
  border: '#dcdcdc',
  dark0: '#222222',
  dark1: oeColorsShared.white,
  dark2: '#666666',
  dark3: '#999999',
  light1: '#f0f0f0',
  lightPrimary: oeColorsShared.primaryLight,
  primary: oeColorsShared.white,
  primaryDark: '#005DC8',
  disabledGrayedOut: 'rgba(0,0,0,0.5)',
  background: '#ffffff',
  dynamicPrimary: oeColorsShared.sunnyOrangeLight,
  backgroundOeBlue20: oeColorsShared.primaryLight,
  text: '#000000',
};

export const oeColorsNextU: ColorsType = {
  ...oeColorsShared,
  ...oeColors,
  primary: '#00F059',
  primaryLight: '#295CA6',
  lightPrimary: '#D9FDE6',
  primaryDark: '#0AAE46',
  text: '#17191E',
  blueMediumJr: '#F1F2F4',
  dropdownHoveredTextColor: '#17191E',
};
